/**
 * Category Scroll to Top Button
 * Gestisce il pulsante scroll to top per la categoria Attrezzatura Cucina (ID 77)
 */
$(document).ready(function () {
    const $scrollToTopButton = $('#categoryScrollToTop');

    // Se il pulsante non esiste, esci
    if (!$scrollToTopButton.length) return;

    // Funzione per scrollare in cima alla pagina
    function scrollToTop() {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
    }

    // Gestisce il click sul pulsante
    $scrollToTopButton.on('click', function (e) {
        e.preventDefault();
        scrollToTop();
    });

    // Gestisce la visibilità del pulsante durante lo scroll
    let lastScrollTop = 0;
    const delta = 80;

    $(window).on('scroll', function () {
        const nowScrollTop = $(window).scrollTop();

        // Mostra il pulsante quando si scrolla verso l'alto dopo un certo delta
        // Nascondilo quando si scrolla verso il basso o si è in cima alla pagina
        if (nowScrollTop > lastScrollTop && nowScrollTop > 0 && nowScrollTop > delta || nowScrollTop < 200) {
            // SCROLLING DOWN o in cima
            $scrollToTopButton.fadeOut(300);
        } else {
            // SCROLLING UP
            $scrollToTopButton.fadeIn(300);
        }

        lastScrollTop = nowScrollTop;
    });
});
